import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { Button, Input, Card } from '@/components/ui'
import { ROUTES } from '@/constants'
import toast from 'react-hot-toast'

const NewInquiryPage = () => {
  const navigate = useNavigate()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [formData, setFormData] = useState({
    customerName: '',
    phone: '',
    email: '',
    address: '',
    city: '',
    pincode: '',
    planInterest: ''
  })

  const handleSubmit = async () => {
    if (!formData.customerName || !formData.phone) {
      toast.error('Please fill in required fields')
      return
    }

    setIsSubmitting(true)
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1500))
    
    toast.success('Inquiry created successfully!')
    navigate(ROUTES.INQUIRIES)
  }

  return (
    <div className="p-4 space-y-4">
      {/* Header */}
      <div className="flex items-center gap-3">
        <button onClick={() => navigate(-1)} className="p-2 -ml-2 hover:bg-gray-100 rounded-lg">
          <ArrowLeft size={24} />
        </button>
        <h1 className="text-lg font-semibold">New Inquiry</h1>
      </div>

      <Card>
        <div className="space-y-4">
          <Input
            label="Customer Name"
            placeholder="Enter full name"
            value={formData.customerName}
            onChange={(e) => setFormData({ ...formData, customerName: e.target.value })}
            required
          />
          
          <Input
            label="Mobile Number"
            type="tel"
            placeholder="10-digit mobile number"
            value={formData.phone}
            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
            required
          />
          
          <Input
            label="Email (Optional)"
            type="email"
            placeholder="customer@email.com"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          />
          
          <Input
            label="Address"
            placeholder="Street address"
            value={formData.address}
            onChange={(e) => setFormData({ ...formData, address: e.target.value })}
          />
          
          <div className="grid grid-cols-2 gap-3">
            <Input
              label="City"
              placeholder="City name"
              value={formData.city}
              onChange={(e) => setFormData({ ...formData, city: e.target.value })}
            />
            <Input
              label="Pincode"
              placeholder="6-digit pincode"
              value={formData.pincode}
              onChange={(e) => setFormData({ ...formData, pincode: e.target.value })}
            />
          </div>

          <Button 
            onClick={handleSubmit} 
            isLoading={isSubmitting}
            fullWidth
            size="lg"
          >
            Create Inquiry
          </Button>
        </div>
      </Card>
    </div>
  )
}

export default NewInquiryPage
